
(function ($) {
  const $homeHeroWrapper = $('.paragraph--type--highlighted-serie');
  if ($homeHeroWrapper) {
    $homeHeroWrapper.each(function(){
      const $category = $(this).find('.node--type-serie > .series-uwv');
      const $title = $(this).find('.node--type-serie > h2');
      const $seriesHeader = $(this).find('.series-header');
      const $storyHeader = $(this).find('.story-header');

      if ($seriesHeader) {
        $title.prependTo($seriesHeader);
        $category.prependTo($seriesHeader);
      }

      if ($storyHeader) {
        $title.prependTo($storyHeader);
        $category.prependTo($storyHeader);
      }

      const $secondBlock = $('.node--view-mode-full .paragraph:nth-child(2)');
      
      if ($secondBlock.hasClass('paragraph--type--poster')) {
        $secondBlock.css({"margin-top":"0px"});
      }
      $(this).find(".view-episodes .view-content").on('init', function(event, slick){
        const $frontpageHeroCheck = $(this).find('.view-episodes .view-content');
        if ($frontpageHeroCheck) {
          const $slickSlides = $(this).find('.slick-slide');
          $slickSlides && $slickSlides.each(index => {
            $slickSlides[index].addEventListener('click', () => {
              const link = $slickSlides[index].querySelectorAll('a')
              if (link.length > 0) {
                link[0].click();
              }
            });
          });
        }
      });
    });

  }


 
})(jQuery);
